
const QUERIES = {
  USERS_LIST: 'users-list',
  ROLES_LIST: 'roles-list',
  ALL_ROLES_LIST: 'all-role-list',
  BUYERS_LIST: 'users-list',
  PRODUCTS_LISTS: 'products-list',
  SELLER_PRODUCTS_LISTS: 'seller-product-list',
  AMAZON_ACCOUNTS: 'amazon-accounts',
  SELLER_ACCOUNTS:'seller-accounts',
  SELLER_PRODUCTS:'seller-products',  
  GOFLOW_PRODUCTS:'goflow-products',  
  CHANNELS_LIST_SETTINGS:'channels_list_settings',
   PRICE_MAPPING_SETTINGS:'price_mapping_settings',
   LOGS:"logs",
  PERMISSIONS_LIST: 'permissions-list',
  CHANNELS_LIST: 'channels-list',
  CURRENCY_LIST: 'currency-list',
  PRODUCT_FEEDS_LIST: 'product_feed_list',
  PRODUCT_REASSIGN_USERS_LIST: 'product-reassign-users-lists',
  PRODUCT_SALES_LIST: 'product-sales-list',
  AMAZON_ACCOUNT_LIST: 'amazon-account-dropdown-list',
  ASSIGN_PRODUCT_LIST: 'assign_product_list',
  AUTH_USER: 'auth_user',
  ALL_PRODUCTS:'all-products',
  Manage_Product_listings:'manage-product-listings',
  ALL_PRODUCTS_PRICINGTOOL:'allproducts'
  // BUYER_CODES_LIST: 'buyer-codes-list',
}

export {QUERIES}
